import { render, staticRenderFns } from "./house.vue?vue&type=template&id=7f64175c&scoped=true&"
import script from "./house.vue?vue&type=script&lang=js&"
export * from "./house.vue?vue&type=script&lang=js&"
import style0 from "./house.vue?vue&type=style&index=0&id=7f64175c&lang=scss&scoped=true&"
import style1 from "./house.vue?vue&type=style&index=1&id=7f64175c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f64175c",
  null
  
)

export default component.exports